import { createSlice } from '@reduxjs/toolkit';

const MachineNoteList = createSlice({
    name: 'machineNoteList',
    initialState: {
        notes: [], // Array to store the machine notes
        totalNotes: 0, // Total number of notes
        filteredNotesCount: 0, // Filtered notes count
    },
    reducers: {
        setMachineNoteList: (state, action) => {
            state.notes = action.payload.notes || [];
            state.totalNotes = action.payload.totalNotes || 0;
            state.filteredNotesCount = action.payload.filteredNotesCount || 0;
        },
        addMachineNote: (state, action) => {
            state.notes.unshift(action.payload); // Add the new note to the beginning of the array
            state.totalNotes += 1; // Increment totalNotes
            state.filteredNotesCount += 1; // Increment filteredNotesCount
        },
    },
});

export const { setMachineNoteList, addMachineNote } = MachineNoteList.actions;
export default MachineNoteList.reducer;